/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Actions.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromFlow from 'Logic/ViewsFlow.js'
import Action from 'DesignSystem/Action/view.js'
import ActionRequired from 'DesignSystem/ActionRequired/view.js'
import React from 'react'
import SubTitle from 'DesignSystem/SubTitle/view.js'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  alignItems: "flex-start",
marginTop: 20})

export default function Actions({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  isNewUser,
hasToAcceptAndSignAgreement,
viewPath= "/App/MyAccount/Content/Profile/Content/UserProfile/Actions"
}) {
    
    
    
    let flow = fromFlow.useFlow()
let setFlowTo = fromFlow.useSetFlowTo(viewPath)
    
    

  return (<React.Fragment
>
<SubTitle
 data-testid="Actions.SubTitle"
 data-view-path="/App/MyAccount/Content/Profile/Content/UserProfile/Actions"
viewPath={`${viewPath}/SubTitle`}
 marginTop={30}
 text="Actions"
/>
<div
 data-testid="Actions.Vertical"
 data-view-path="/App/MyAccount/Content/Profile/Content/UserProfile/Actions"
 className={`views-block ${styles.Vertical}`}
>
{
isNewUser ? 
<ActionRequired
 data-testid="Actions.ActionRequired"
 data-view-path="/App/MyAccount/Content/Profile/Content/UserProfile/Actions"
viewPath={`${viewPath}/ActionRequired`}
 text="Add your company"
 onClick={() => setFlowTo("/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content")}
 isSelected={flow.has("/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content")}
/>
 : null
}
{
hasToAcceptAndSignAgreement ? 
<ActionRequired
 data-testid="Actions.ActionRequired:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/UserProfile/Actions"
viewPath={`${viewPath}/ActionRequired`}
 marginTop={8}
 text="Accept and sign agreement"
 onClick={() => setFlowTo("/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature")}
 isSelected={flow.has("/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature")}
/>
 : null
}
<Action
 data-testid="Actions.Action"
 data-view-path="/App/MyAccount/Content/Profile/Content/UserProfile/Actions"
viewPath={`${viewPath}/Action`}
 marginTop={8}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Item/Content/Change'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../Item/Content/Change'))}
 text="Change your personal details"
/>
<Action
 data-testid="Actions.Action:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/UserProfile/Actions"
viewPath={`${viewPath}/Action`}
 marginTop={8}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Item/Content/ChangePassword'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../Item/Content/ChangePassword'))}
 text="Change your password"
/>
</div>
{children}
</React.Fragment>)
}